import { useCallback } from "react";

const DateInput = ({ value, onChange, className }) => {
    const onChangeValue = useCallback((e) => {
        onChange(e.target.value);
    }, [onChange]);

    return (
        <input type="date" value={value} onChange={onChangeValue} className={className ?? "rounded-lg"} />
    );
}

export default DateInput;